import { Check, X } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"

export const CopilotTag = ({
  id,
  name,
  onApprove,
  onCancel,
}: {
  id: string
  name: string
  onApprove?: () => void
  onCancel?: () => void
}) => {
  return (
    <div
      key={id}
      className="grid-cols-1fr-auto border-on-plum-surface bg-plum-surface-subdued text-on-plum-surface hover:bg-plum-surface grid cursor-pointer items-center gap-0.5 rounded-md border text-sm">
      <p className="p-1.5">{name}</p>
      <div className="flex gap-2">
        <Button variant="circle" className="h-fit w-fit p-1" onClick={onCancel}>
          <X />
        </Button>
        <Button variant="circle" className="h-fit w-fit p-1" onClick={onApprove}>
          <Check />
        </Button>
      </div>
    </div>
  )
}
